var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyLibraryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 29 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,21.6H6.9c-3.4,0-6.2-2.8-6.2-6.3c0-2.2,1.2-4.2,3-5.3C4,7.1,6.5,4.9,9.5,4.9c0.3,0,0.7,0,1,0.1 c0.5-1.1,1.3-2,2.2-2.8l0,0c1.4-1.2,3.3-1.8,5.1-1.8c4.1,0,7.5,3,8,7c1.1,0.5,2.1,1.2,2.9,2.2c1.1,1.3,1.6,3,1.6,4.7 C30.3,18.3,27,21.6,23,21.6z M9.5,6.8c-2.2,0-3.9,1.7-4,3.9l0,0.6L5,11.4c-1.5,0.7-2.4,2.3-2.4,3.9c0,2.4,1.9,4.4,4.3,4.4H23 c3,0,5.5-2.5,5.5-5.5c0-1.3-0.4-2.5-1.2-3.5c-0.7-0.8-1.6-1.4-2.6-1.8l-0.6-0.2l0-0.6c-0.2-3.3-2.9-5.9-6.2-5.9 c-1.4,0-2.8,0.5-3.9,1.4l0,0c-0.9,0.7-1.6,1.7-1.9,2.7l-0.3,0.9L10.8,7C10.3,6.8,9.9,6.8,9.5,6.8z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyLibraryIcon);
export default __webpack_public_path__ + "static/media/myLibrary_icon.ceb2dbed0c76233089f5a1cb4b8a455b.svg";
export { ForwardRef as ReactComponent };